// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_cmp_rename_tab = require("./MM_cmp_rename_tab.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Paper = require("@mui/material/Paper").default;
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Button = require("@mui/material/Button").default;
var Edit = require("@mui/icons-material/Edit").default;
var ButtonGroup = require("@mui/material/ButtonGroup").default;
var ArrowUpward = require("@mui/icons-material/ArrowUpward").default;
var ArrowDownward = require("@mui/icons-material/ArrowDownward").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var OpenInBrowser = require("@mui/icons-material/OpenInBrowser").default;

function MM_cmp_tabs_manager(props) {
  var onOpenEditor = props.onOpenEditor;
  var onOpenExplorer = props.onOpenExplorer;
  var onTabClose = props.onTabClose;
  var onTabFocus = props.onTabFocus;
  var onTabMoveDown = props.onTabMoveDown;
  var onTabMoveUp = props.onTabMoveUp;
  var onTabRename = props.onTabRename;
  var modalRef = props.modalRef;
  var rndOpenButtons = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "baseline",
                style: {
                  marginBottom: "20px"
                },
                children: Caml_option.some(null)
              }, "Open new tab: ", React.createElement(Button, {
                    onClick: (function (param) {
                        onOpenEditor();
                      }),
                    variant: "outlined",
                    children: "Editor"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onOpenExplorer();
                      }),
                    variant: "outlined",
                    children: "Explorer"
                  }));
  };
  var rndTabButtons = function (tab) {
    return React.createElement(ButtonGroup, {
                variant: "outlined",
                size: "small",
                children: null
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onTabClose(tab.id);
                      }),
                    title: "Close",
                    children: Caml_option.some(React.createElement(DeleteForever, {}))
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onTabFocus(tab.id);
                      }),
                    title: "Go to this tab",
                    children: Caml_option.some(React.createElement(OpenInBrowser, {}))
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        MM_react_common.openModalPaneWithTitle(modalRef, "Rename tab", (function (close) {
                                return React.createElement(MM_cmp_rename_tab.make, {
                                            initName: tab.label,
                                            onOk: (function (newName) {
                                                close();
                                                onTabRename(tab.id, newName);
                                              }),
                                            onCancel: close
                                          });
                              }));
                      }),
                    title: "Rename",
                    children: Caml_option.some(React.createElement(Edit, {}))
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onTabMoveDown(tab.id);
                      }),
                    title: "Move down",
                    children: Caml_option.some(React.createElement(ArrowDownward, {}))
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onTabMoveUp(tab.id);
                      }),
                    title: "Move up",
                    children: Caml_option.some(React.createElement(ArrowUpward, {}))
                  }));
  };
  var rndTabControls = function (tab) {
    var icon = tab.icon;
    return JsxPPXReactSupportU.createElementVariadicWithKey(tab.id, Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, [
                rndTabButtons(tab),
                React.createElement(Paper, {
                      style: {
                        padding: "5px"
                      },
                      children: Caml_option.some(icon !== undefined ? React.createElement("span", undefined, Caml_option.valFromOption(icon), " " + tab.label) : tab.label)
                    })
              ]);
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 1,
              style: {
                margin: "10px"
              },
              children: Caml_option.some(null)
            }, rndOpenButtons(), props.tabs.map(rndTabControls));
}

var make = MM_cmp_tabs_manager;

exports.make = make;
/* react Not a pure module */
